(function () {

  const KEY = 'dfToolsProfile';

  /* =========================================================

     PERFIL

  ========================================================= */

  const get = () => {

    try {

      return JSON.parse(sessionStorage.getItem(KEY) || '{}');

    } catch (e) {

      return {};

    }

  };

  const set = (x) => {

    const p = { ...get(), ...x };

    sessionStorage.setItem(KEY, JSON.stringify(p));

    return p;

  };

  const n = (v) => Number(String(v || '').replace(',', '.'));

  const fmt = (v, d = 0) =>

    Number(v).toLocaleString('es-ES', {

      maximumFractionDigits: d,

      minimumFractionDigits: d

    });

  /* =========================================================

     CONFIGURACIÓN

  ========================================================= */

  const activity = {

    sedentary: 1.2,

    light: 1.375,

    moderate: 1.55,

    high: 1.725,

    very_high: 1.9

  };

  const proteinRanges = {

    lose: [1.6, 2.0],

    maintain: [1.2, 1.6],

    gain: [1.6, 2.2]

  };

  const goals = {

    lose: -0.15,

    maintain: 0,

    gain: 0.10

  };

  const goalLabels = {

    lose: 'Perder grasa',

    maintain: 'Mantener',

    gain: 'Ganar masa'

  };

  /* =========================================================

     RUTAS

  ========================================================= */

  const toolPages = {

    bmi: '/pages/calculadora-imc',

    tdee: '/pages/calculadora-calorias',

    macros: '/pages/calculadora-macros',

    protein: '/pages/calculadora-proteina',

    water: '/pages/calculadora-agua'

  };

  const nextPages = {

    bmi: '/pages/calculadora-calorias',

    calories: '/pages/calculadora-macros',

    macros: '/pages/calculadora-proteina',

    protein: '/pages/calculadora-agua',

    water: '/pages/mi-resumen-nutricional'

  };

  /* =========================================================

     FÓRMULAS

  ========================================================= */

  function bmi(w, h) {

    return w / Math.pow(h / 100, 2);

  }

  function healthyWeight(h) {

    const m = h / 100;

    return [

      18.5 * m * m,

      24.9 * m * m

    ];

  }

  function bmr(w, h, age, sex) {

    const base =

      10 * w +

      6.25 * h -

      5 * age;

    if (sex === 'male') {

      return base + 5;

    }

    if (sex === 'female') {

      return base - 161;

    }

    return null;

  }

  function bmrRange(w, h, age) {

    const male =

      bmr(w, h, age, 'male');

    const female =

      bmr(w, h, age, 'female');

    return [

      Math.min(male, female),

      Math.max(male, female)

    ];

  }

  /* =========================================================

     PROGRESO

  ========================================================= */

  function progress(p) {

    return ['bmi', 'tdee', 'macros', 'proteinCompleted', 'water']

      .filter(k => p[k] != null)

      .length * 20;

  }

  /* =========================================================

     PERFIL SUPERIOR

  ========================================================= */

  function renderProfile(root, p) {

    const el =

      root.querySelector('[data-profile]');

    if (!el) return;

    const pc = progress(p);

    const items = [

      ['bmi', 'IMC', toolPages.bmi],

      ['tdee', 'Calorías', toolPages.tdee],

      ['macros', 'Macros', toolPages.macros],

      ['proteinCompleted', 'Proteína', toolPages.protein],

      ['water', 'Agua', toolPages.water]

    ];

    let title =

      'TU PERFIL · ' +

      pc +

      '% COMPLETADO';

    if (pc === 100) {

      title =

        '✓ PERFIL NUTRICIONAL COMPLETADO';

    }

    el.innerHTML =

      '<div class="df-profile-top">' +

        '<div class="df-eyebrow">' +

          title +

        '</div>' +

        (

          pc === 100

            ? '<div class="df-profile-finished">Ya tienes tus principales estimaciones. Puedes revisar cualquier cálculo cuando quieras.</div>'

            : ''

        ) +

      '</div>' +

      '<div class="df-progress">' +

        '<span style="width:' + pc + '%"></span>' +

      '</div>' +

      '<div class="df-nav">' +

        items.map(item => {

          const done =

            p[item[0]] != null;

          return (

            '<a href="' +

              item[2] +

              '" class="df-chip ' +

              (done ? 'is-done' : '') +

            '">' +

              (done ? '✓ ' : '') +

              item[1] +

            '</a>'

          );

        }).join('') +

      '</div>' +

      (

        pc === 100

          ? '<div class="df-profile-extras">' +

              '<a href="/pages/calculadora-peso-saludable">🎯 Peso saludable</a>' +

              '<a href="/pages/calculadora-creatina">🥄 Creatina</a>' +

            '</div>'

          : ''

      );

  }

  /* =========================================================

     PRECARGA

  ========================================================= */

  function prefill(root, p) {

    root

      .querySelectorAll('[data-key]')

      .forEach(el => {

        const key =

          el.dataset.key;

        /*

          Macros debe utilizar automáticamente

          las calorías objetivo calculadas.

        */

        if (

          key === 'calories' &&

          p.targetCalories

        ) {

          el.value =

            Math.round(p.targetCalories);

          return;

        }

        if (

          p[key] !== undefined &&

          p[key] !== null &&

          p[key] !== ''

        ) {

          el.value = p[key];

        }

      });

  }

  /* =========================================================

     BOTÓN CONTINUAR

  ========================================================= */

  function setupContinueButton(root, type) {

    const button =

      root.querySelector('[data-continue]');

    if (!button) return;

    const nextUrl =

      nextPages[type];

    if (!nextUrl) {

      button.style.display =

        'none';

      return;

    }

    button.setAttribute(

      'href',

      nextUrl

    );

  }

  /* =========================================================

     IMC VISUAL

  ========================================================= */

  function showBmiResult(

    root,

    value,

    height

  ) {

    const r =

      root.querySelector('[data-output]');

    if (!r) return;

    let label;

    if (value < 18.5) {

      label = 'Bajo peso';

    } else if (value < 25) {

      label = 'Peso normal';

    } else if (value < 30) {

      label = 'Sobrepeso';

    } else {

      label = 'Obesidad';

    }

    const healthy =

      healthyWeight(height);

    /*

      Escala visual 14–40.

      Las posiciones se calculan de acuerdo

      con los puntos de corte utilizados.

    */

    const minScale = 14;

    const maxScale = 40;

    const position =

      Math.max(

        1,

        Math.min(

          99,

          (

            (value - minScale) /

            (maxScale - minScale)

          ) * 100

        )

      );

    const cut185 =

      ((18.5 - minScale) /

      (maxScale - minScale)) *

      100;

    const cut25 =

      ((25 - minScale) /

      (maxScale - minScale)) *

      100;

    const cut30 =

      ((30 - minScale) /

      (maxScale - minScale)) *

      100;

    r.innerHTML =

      '<div class="df-bmi-result">' +

        '<div class="df-result-icon">⚖️</div>' +

        '<div class="df-result-kicker">TU IMC</div>' +

        '<div class="df-bmi-number">' +

          fmt(value, 1) +

        '</div>' +

        '<div class="df-result-status">' +

          label +

        '</div>' +

        '<div class="df-bmi-scale-wrap">' +

          '<div class="df-bmi-scale">' +

            '<span class="df-bmi-zone df-bmi-low" style="width:' +

              cut185 +

            '%"></span>' +

            '<span class="df-bmi-zone df-bmi-normal" style="width:' +

              (cut25 - cut185) +

            '%"></span>' +

            '<span class="df-bmi-zone df-bmi-over" style="width:' +

              (cut30 - cut25) +

            '%"></span>' +

            '<span class="df-bmi-zone df-bmi-high" style="width:' +

              (100 - cut30) +

            '%"></span>' +

            '<span class="df-bmi-marker" style="left:' +

              position +

            '%"></span>' +

          '</div>' +

          '<div class="df-bmi-legend">' +

            '<span>Bajo</span>' +

            '<span>Normal</span>' +

            '<span>Sobrepeso</span>' +

            '<span>Obesidad</span>' +

          '</div>' +

        '</div>' +

        '<div class="df-result-info">' +

          '<span>Rango de peso orientativo para tu altura</span>' +

          '<strong>' +

            fmt(healthy[0], 1) +

            '–' +

            fmt(healthy[1], 1) +

            ' kg' +

          '</strong>' +

        '</div>' +

        '<a class="df-inline-link" href="/pages/calculadora-peso-saludable">' +

          'Ver calculadora de peso saludable →' +

        '</a>' +

      '</div>';

  }

  /* =========================================================

     CALORÍAS VISUAL

  ========================================================= */

  function showCaloriesResult(

    root,

    data

  ) {

    const r =

      root.querySelector('[data-output]');

    if (!r) return;

    const goalText =

      goalLabels[data.goal] ||

      'Mantener';

    /*

      Caso sexo no indicado:

      mostramos rangos.

    */

    if (data.range) {

      const basalLow =

        data.basalRange[0];

      const basalHigh =

        data.basalRange[1];

      const tdeeLow =

        data.tdeeRange[0];

      const tdeeHigh =

        data.tdeeRange[1];

      const targetLow =

        data.targetRange[0];

      const targetHigh =

        data.targetRange[1];

      r.innerHTML =

        '<div class="df-cal-result">' +

          '<div class="df-result-icon">🔥</div>' +

          '<div class="df-result-kicker">OBJETIVO DIARIO ESTIMADO</div>' +

          '<div class="df-cal-main df-cal-main--range">' +

            fmt(targetLow) +

            '–' +

            fmt(targetHigh) +

          '</div>' +

          '<div class="df-result-unit">kcal/día</div>' +

          '<div class="df-result-status">' +

            goalText +

          '</div>' +

          '<div class="df-cal-secondary">' +

            '<div>' +

              '<span>En reposo</span>' +

              '<strong>' +

                fmt(basalLow) +

                '–' +

                fmt(basalHigh) +

                ' kcal' +

              '</strong>' +

              '<small>Metabolismo basal</small>' +

            '</div>' +

            '<div>' +

              '<span>Gasto total</span>' +

              '<strong>' +

                fmt(tdeeLow) +

                '–' +

                fmt(tdeeHigh) +

                ' kcal' +

              '</strong>' +

              '<small>Actividad incluida</small>' +

            '</div>' +

          '</div>' +

          '<p class="df-result-explanation">' +

            'Como has preferido no indicar el sexo utilizado en la fórmula, mostramos un rango entre ambas estimaciones.' +

          '</p>' +

        '</div>';

      return;

    }

    const difference =

      data.target -

      data.tdee;

    let differenceText = '';

    if (difference < -1) {

      differenceText =

        'El objetivo supone aproximadamente <strong>' +

        fmt(Math.abs(difference)) +

        ' kcal/día menos</strong> que tu gasto estimado.';

    } else if (difference > 1) {

      differenceText =

        'El objetivo supone aproximadamente <strong>' +

        fmt(difference) +

        ' kcal/día más</strong> que tu gasto estimado.';

    } else {

      differenceText =

        'El objetivo se aproxima a tu gasto energético diario estimado.';

    }

    r.innerHTML =

      '<div class="df-cal-result">' +

        '<div class="df-result-icon">🔥</div>' +

        '<div class="df-result-kicker">TU OBJETIVO DIARIO</div>' +

        '<div class="df-cal-main">' +

          fmt(data.target) +

        '</div>' +

        '<div class="df-result-unit">kcal/día</div>' +

        '<div class="df-result-status">' +

          goalText +

        '</div>' +

        '<div class="df-cal-secondary">' +

          '<div>' +

            '<span>En reposo</span>' +

            '<strong>' +

              fmt(data.basal) +

              ' kcal' +

            '</strong>' +

            '<small>Metabolismo basal</small>' +

          '</div>' +

          '<div>' +

            '<span>Gasto total</span>' +

            '<strong>' +

              fmt(data.tdee) +

              ' kcal' +

            '</strong>' +

            '<small>Actividad incluida</small>' +

          '</div>' +

        '</div>' +

        '<p class="df-result-explanation">' +

          differenceText +

        '</p>' +

      '</div>';

  }

  /* =========================================================

     MACROS VISUAL

  ========================================================= */

  function showMacrosResult(

    root,

    data

  ) {

    const r =

      root.querySelector('[data-output]');

    if (!r) return;

    const proteinCalories =

      data.protein * 4;

    const fatCalories =

      data.fat * 9;

    const carbCalories =

      data.carbs * 4;

    const total =

      proteinCalories +

      fatCalories +

      carbCalories;

    const proteinPct =

      Math.round(

        proteinCalories /

        total *

        100

      );

    const fatPct =

      Math.round(

        fatCalories /

        total *

        100

      );

    const carbPct =

      100 -

      proteinPct -

      fatPct;

    r.innerHTML =

      '<div class="df-macros-result">' +

        '<div class="df-result-icon">📊</div>' +

        '<div class="df-result-kicker">TU DISTRIBUCIÓN DIARIA</div>' +

        '<div class="df-macros-calories">' +

          fmt(data.calories) +

          ' <span>kcal/día</span>' +

        '</div>' +

        '<div class="df-macro-grid">' +

          '<div class="df-macro-card df-macro-protein">' +

            '<span class="df-macro-icon">💪</span>' +

            '<strong>' +

              fmt(data.protein) +

              ' g' +

            '</strong>' +

            '<b>Proteína</b>' +

            '<small>' +

              proteinPct +

              '% de las kcal' +

            '</small>' +

          '</div>' +

          '<div class="df-macro-card df-macro-fat">' +

            '<span class="df-macro-icon">🥑</span>' +

            '<strong>' +

              fmt(data.fat) +

              ' g' +

            '</strong>' +

            '<b>Grasas</b>' +

            '<small>' +

              fatPct +

              '% de las kcal' +

            '</small>' +

          '</div>' +

          '<div class="df-macro-card df-macro-carb">' +

            '<span class="df-macro-icon">⚡</span>' +

            '<strong>' +

              fmt(data.carbs) +

              ' g' +

            '</strong>' +

            '<b>Hidratos</b>' +

            '<small>' +

              carbPct +

              '% de las kcal' +

            '</small>' +

          '</div>' +

        '</div>' +

        '<div class="df-macro-bar">' +

          '<span class="df-macro-bar-protein" style="width:' + proteinPct + '%"></span>' +

          '<span class="df-macro-bar-fat" style="width:' + fatPct + '%"></span>' +

          '<span class="df-macro-bar-carb" style="width:' + carbPct + '%"></span>' +

        '</div>' +

      '</div>';

  }

  /* =========================================================

     PROTEÍNA VISUAL

  ========================================================= */

  function showProteinResult(

    root,

    low,

    high,

    target

  ) {

    const r =

      root.querySelector('[data-output]');

    if (!r) return;

    /*

      Ejemplo de distribución diaria.

      No se intenta convertir el objetivo

      completo a un único alimento.

    */

    const breakfast =

      Math.round(target * 0.20);

    const lunch =

      Math.round(target * 0.30);

    const snack =

      Math.round(target * 0.20);

    const dinner =

      target -

      breakfast -

      lunch -

      snack;

    r.innerHTML =

      '<div class="df-protein-result">' +

        '<div class="df-result-icon">💪</div>' +

        '<div class="df-result-kicker">TU PROTEÍNA DIARIA</div>' +

        '<div class="df-protein-range">' +

          fmt(low) +

          '–' +

          fmt(high) +

          ' g' +

        '</div>' +

        '<div class="df-result-unit">' +

          'de proteína al día' +

        '</div>' +

        '<div class="df-protein-target">' +

          'Referencia intermedia: <strong>≈ ' +

          fmt(target) +

          ' g/día</strong>' +

        '</div>' +

        '<div class="df-food-title">' +

          '¿Qué significa en comida?' +

        '</div>' +

        '<div class="df-food-grid">' +

          '<div class="df-food-card">' +

            '<span>🍗</span>' +

            '<b>100 g de pollo</b>' +

            '<small>≈ 30 g de proteína</small>' +

          '</div>' +

          '<div class="df-food-card">' +

            '<span>🐟</span>' +

            '<b>100 g de pescado</b>' +

            '<small>≈ 20–25 g de proteína</small>' +

          '</div>' +

          '<div class="df-food-card">' +

            '<span>🥚</span>' +

            '<b>2 huevos</b>' +

            '<small>≈ 12–14 g de proteína</small>' +

          '</div>' +

        '</div>' +

        '<div class="df-distribution">' +

          '<div class="df-distribution-title">' +

            'Ejemplo de reparto diario' +

          '</div>' +

          '<div class="df-distribution-grid">' +

            '<span>Desayuno <b>≈ ' +

              breakfast +

              ' g</b></span>' +

            '<span>Comida <b>≈ ' +

              lunch +

              ' g</b></span>' +

            '<span>Merienda <b>≈ ' +

              snack +

              ' g</b></span>' +

            '<span>Cena <b>≈ ' +

              dinner +

              ' g</b></span>' +

          '</div>' +

        '</div>' +

        '<p class="df-result-explanation">' +

          'No necesitas obtener toda la proteína de un único alimento. Puedes repartirla entre diferentes comidas y fuentes de proteína.' +

        '</p>' +

        '<a class="df-inline-link" href="/pages/calculadora-creatina">' +

          '🥄 Ver calculadora de creatina →' +

        '</a>' +

      '</div>';

  }

  /* =========================================================

     AGUA VISUAL

  ========================================================= */

  function showWaterResult(

    root,

    litres

  ) {

    const r =

      root.querySelector('[data-output]');

    if (!r) return;

    const glasses =

      Math.round(

        litres /

        0.25

      );

    r.innerHTML =

      '<div class="df-water-result">' +

        '<div class="df-result-icon">💧</div>' +

        '<div class="df-result-kicker">HIDRATACIÓN DIARIA ESTIMADA</div>' +

        '<div class="df-water-main">' +

          fmt(litres, 1) +

          ' L' +

        '</div>' +

        '<div class="df-result-unit">' +

          'de agua al día' +

        '</div>' +

        '<div class="df-water-glasses">' +

          '<span>🥛</span>' +

          '<div>' +

            '<strong>≈ ' +

              glasses +

              ' vasos</strong>' +

            '<small>Tomando como referencia vasos de 250 ml</small>' +

          '</div>' +

        '</div>' +

        '<div class="df-complete-box">' +

          '<strong>✓ Análisis principal completado</strong>' +

          '<span>Ya puedes revisar tus resultados o explorar otras herramientas.</span>' +

        '</div>' +

      '</div>';

  }

  /* =========================================================

     PESO SALUDABLE

  ========================================================= */

  function showHealthyResult(root, height, weight) {
    const r = root.querySelector('[data-output]');
    const range = healthyWeight(height);
    const value = bmi(weight, height);
    const status = weight < range[0] ? 'Por debajo del rango de referencia' : weight > range[1] ? 'Por encima del rango de referencia' : 'Dentro del rango de referencia';
    const difference = weight < range[0] ? range[0] - weight : weight > range[1] ? weight - range[1] : 0;
    r.innerHTML = `<div class="df-result-icon">🎯</div><div class="df-result-kicker">REFERENCIA SEGÚN ALTURA</div><div class="df-healthy-main">${fmt(range[0],1)}–${fmt(range[1],1)} kg</div><div class="df-result-info"><span>Tu peso actual</span><strong>${fmt(weight,1)} kg</strong><span>IMC: ${fmt(value,1)} · ${status}</span></div>${difference ? `<p class="df-result-explanation">Distancia al límite más cercano: ${fmt(difference,1)} kg. No es una recomendación de perder o ganar ese peso.</p>` : ''}<p class="df-result-explanation">Rango estadístico de IMC 18,5–24,9 para adultos. No mide composición corporal ni determina por sí solo el peso ideal o el estado de salud. Puede no ser adecuado en embarazo, deportistas con mucha masa muscular y otras situaciones.</p>`;
  }

  /* =========================================================

     CREATINA

  ========================================================= */

  function showCreatineResult(root, weight, size, loading, training) {
    const r = root.querySelector('[data-output]');
    const daily = 5;
    const load = weight * 0.3;
    const days = Math.floor(size / daily);
    r.innerHTML = `<div class="df-result-icon">🥄</div><div class="df-result-kicker">DOSIS HABITUAL DE MANTENIMIENTO EN ADULTOS</div><div class="df-creatine-main">3–5 g/día</div><p class="df-result-explanation">Para adultos sanos, la creatina monohidrato suele utilizarse en dosis de mantenimiento de 3–5 g al día. El peso y el entrenamiento no permiten deducir una dosis individual exacta.</p><div class="df-creatine-summary"><div><span>Envase de ${fmt(size)} g</span><strong>≈ ${fmt(days)} días</strong><small>A 5 g/día, sin carga</small></div><div><span>Entrenamiento de fuerza</span><strong>${training === 'yes' ? 'Sí' : 'No'}</strong></div></div>${loading === 'yes' ? `<div class="df-result-info"><span>Fase de carga opcional (no necesaria)</span><strong>≈ ${fmt(load,1)} g/día</strong><span>Durante 5–7 días, repartidos en varias tomas; después, mantenimiento de 3–5 g/día. La carga consume más producto y puede causar molestias digestivas.</span></div>` : ''}<p class="df-result-explanation">Uso orientativo, no una prescripción. Consulta con un profesional sanitario si tienes enfermedad renal, tomas medicación, estás embarazada o en lactancia. No está destinada a menores.</p>`;
  }

  /* =========================================================

     ERROR

  ========================================================= */

  function error(root) {

    root

      .querySelector('.df-error')

      ?.remove();

    const e =

      document.createElement('div');

    e.className =

      'df-error';

    e.textContent =

      'Revisa los datos introducidos.';

    root

      .querySelector('form')

      .appendChild(e);

  }

  /* =========================================================

     INICIALIZAR

  ========================================================= */

  function init(root) {

    let p = get();

    prefill(root, p);

    renderProfile(root, p);

    const type =

      root.dataset.tool;

    setupContinueButton(

      root,

      type

    );

    const form =

      root.querySelector('form');

    if (!form) return;

    form.addEventListener(

      'submit',

      e => {

        e.preventDefault();

        const vals = {};

        root

          .querySelectorAll('[data-key]')

          .forEach(el => {

            vals[el.dataset.key] =

              el.value;

          });

        const w =

          n(vals.weight);

        const h =

          n(vals.height);

        const age =

          n(vals.age);

        let out = {};

        /* =====================================================

           IMC

        ===================================================== */

        if (type === 'bmi') {

          if (

            !(

              w >= 30 &&

              w <= 300 &&

              h >= 100 &&

              h <= 250

            )

          ) {

            return error(root);

          }

          const x =

            bmi(w, h);

          out = {

            weight: w,

            height: h,

            bmi: x

          };

          showBmiResult(

            root,

            x,

            h

          );

        }

        /* =====================================================

           CALORÍAS

        ===================================================== */

        if (type === 'calories') {

          if (

            !(

              w > 0 &&

              h > 0 &&

              age >= 18 &&

              age <= 100 &&

              vals.sex &&

              vals.activity

            )

          ) {

            return error(root);

          }

          const factor =

            activity[vals.activity];

          const modifier =

            1 +

            (goals[vals.goal] || 0);

          /*

            PREFIERE NO INDICAR SEXO

          */

          if (

            vals.sex === 'unspecified'

          ) {

            const basalRange =

              bmrRange(

                w,

                h,

                age

              );

            const tdeeRange =

              basalRange.map(

                value =>

                  value * factor

              );

            const targetRange =

              tdeeRange.map(

                value =>

                  value * modifier

              );

            /*

              Guardamos el punto medio para

              permitir continuar hacia macros.

            */

            const basal =

              (

                basalRange[0] +

                basalRange[1]

              ) / 2;

            const tdee =

              (

                tdeeRange[0] +

                tdeeRange[1]

              ) / 2;

            const target =

              (

                targetRange[0] +

                targetRange[1]

              ) / 2;

            out = {

              weight: w,

              height: h,

              age: age,

              sex: vals.sex,

              activity: vals.activity,

              goal: vals.goal,

              bmr: basal,

              tdee: tdee,

              targetCalories: target,
                targetCaloriesRange: targetRange

            };

            showCaloriesResult(

              root,

              {

                range: true,

                basalRange,

                tdeeRange,

                targetRange,

                goal: vals.goal

              }

            );

          } else {

            const basal =

              bmr(

                w,

                h,

                age,

                vals.sex

              );

            const tdee =

              basal *

              factor;

            const target =

              tdee *

              modifier;

            out = {

              weight: w,

              height: h,

              age: age,

              sex: vals.sex,

              activity: vals.activity,

              goal: vals.goal,

              bmr: basal,

              tdee: tdee,

              targetCalories: target

            };

            showCaloriesResult(

              root,

              {

                range: false,

                basal,

                tdee,

                target,

                goal: vals.goal

              }

            );

          }

        }

        /* =====================================================

           MACROS

        ===================================================== */

        if (type === 'macros') {

          const cal =

            n(vals.calories) ||

            p.targetCalories;

          if (!(cal > 0)) {

            return error(root);

          }

          const goal =

            vals.goal ||

            p.goal ||

            'maintain';

          const ww =

            w ||

            p.weight;

          if (!(ww > 0)) {

            return error(root);

          }

          const protKg =

            goal === 'gain'

              ? 1.8

              : goal === 'lose'

                ? 1.8

                : 1.4;

          const pr =

            ww *

            protKg;

          const fat =

            ww *

            0.8;

          const carb =

            Math.max(

              0,

              (

                cal -

                pr * 4 -

                fat * 9

              ) / 4

            );

          out = {

            goal: goal,

            macros: true,

            macroProtein: pr,

            fat: fat,

            carbs: carb,

            targetCalories: cal

          };

          showMacrosResult(

            root,

            {

              calories: cal,

              protein: pr,

              fat: fat,

              carbs: carb

            }

          );

        }

        /* =====================================================

           PROTEÍNA

        ===================================================== */

        if (type === 'protein') {

          const ww =

            w ||

            p.weight;

          const goal =

            vals.goal ||

            p.goal ||

            'maintain';

          if (!(ww > 0)) {

            return error(root);

          }

          const range =

            proteinRanges[goal] ||

            proteinRanges.maintain;

          const low =

            ww *

            range[0];

          const high =

            ww *

            range[1];

          const target =

            (low + high) /

            2;

          out = {

            weight: ww,

            goal: goal,

            protein: target,
                proteinCompleted: true

          };

          showProteinResult(

            root,

            low,

            high,

            target

          );

        }

        /* =====================================================

           AGUA

        ===================================================== */

        if (type === 'water') {

          const ww =

            w ||

            p.weight;

          if (!(ww > 0)) {

            return error(root);

          }

          const mins =

            n(vals.exercise) ||

            0;

          const litres =

            ww * 0.035 +

            (mins / 30) * 0.35;

          out = {

            weight: ww,

            water: litres

          };

          showWaterResult(

            root,

            litres

          );

        }

        /* =====================================================

           PESO SALUDABLE

        ===================================================== */

        if (type === 'healthy') {
          if (!(h >= 100 && h <= 250 && w >= 30 && w <= 300)) return error(root);
          out = { height: h, weight: w, healthy: true };
          showHealthyResult(root, h, w);
        }

        /* =====================================================

           CREATINA

        ===================================================== */

        if (type === 'creatine') {
          const ww = w || p.weight;
          const size = n(vals.size);
          if (!(ww >= 30 && ww <= 300 && size >= 50 && size <= 2000)) return error(root);
          out = { weight: ww, creatine: true, creatineSize: size };
          showCreatineResult(root, ww, size, vals.loading, vals.training);
        }

        /* =====================================================

           GUARDAR

        ===================================================== */

                const prior = get();
        const changed = (key) => out[key] !== undefined && prior[key] !== undefined && String(out[key]) !== String(prior[key]);
        if (changed('weight') || changed('height') || changed('goal')) {
          // A changed base invalidates calculations from earlier visits.
          const reset = { bmi: null, tdee: null, macros: null, macroProtein: null, protein: null, proteinCompleted: null, fat: null, carbs: null, water: null, targetCalories: null, targetCaloriesRange: null, bmr: null };
          p = set({ ...reset, ...vals, ...out });
        } else {
          p = set({ ...vals, ...out });
        }

        renderProfile(

          root,

          p

        );

        root

          .querySelector('.df-error')

          ?.remove();

        /* =====================================================

           ANALYTICS

        ===================================================== */

        window.dataLayer =

          window.dataLayer ||

          [];

        window.dataLayer.push({

          event: 'tool_completed',

          tool_name: type,

          goal: p.goal || ''

        });

      }

    );

    window.dataLayer =

      window.dataLayer ||

      [];

    window.dataLayer.push({

      event: 'tool_started',

      tool_name: type

    });

  }

  /* =========================================================

     API

  ========================================================= */

  window.DFTools = {

    init,

    get,

    set

  };

  document

    .querySelectorAll(

      '.df-tools[data-tool]'

    )

    .forEach(init);

/* =============================================

   RESUMEN NUTRICIONAL

\============================================= */

function initSummary() {

  const root = document.querySelector('[data-df-summary]');

  if (!root) return;

  const p = get();

  const target = document.getElementById('df-summary-content');

  if (!target) return;

  const available = [

    p.bmi,

    p.targetCalories,

    p.macros,

    p.proteinCompleted,
      p.water

  ].filter(v => v != null).length;

  if (!available) {

    target.innerHTML = `

      <div class="df-card">

        <h2>Todavía no tienes resultados</h2>

        <p class="df-muted">

          Empieza por la calculadora de IMC para crear tu informe.

        </p>

        <a class="df-btn" href="/pages/calculadora-imc">

          Empezar mi análisis

        </a>

      </div>

    `;

    return;

  }

  const bmiLabel = value => {

    if (value < 18.5) return 'Bajo peso';

    if (value < 25) return 'Peso normal';

    if (value < 30) return 'Sobrepeso';

    return 'Obesidad';

  };

  const stat = (icon, label, value, detail = '', wide = false) => `

    <div class="df-summary-stat ${wide ? 'df-summary-stat--wide' : ''}">

      <span>${icon} ${label}</span>

      <strong>${value}</strong>

      <small>${detail}</small>

    </div>

  `;

  const goalText = {

    lose: 'Perder grasa',

    maintain: 'Mantener peso',

    gain: 'Ganar masa'

  };

  const activityText = {

    sedentary: 'Sedentaria',

    light: 'Ligera',

    moderate: 'Moderada',

    high: 'Alta',

    very_high: 'Muy alta'

  };

  let cards = '';

  if (p.bmi != null) {

    cards += stat(

      '⚖️',

      'Índice de masa corporal',

      fmt(p.bmi, 1),

      bmiLabel(p.bmi)

    );

  }

  if (p.targetCalories != null) {

    cards += stat(

      '🔥',

      'Objetivo energético',

      fmt(p.targetCalories) + ' kcal',

      'Estimación diaria'

    );

  }

  if (p.proteinCompleted && p.protein != null) {

    cards += stat(

      '💪',

      'Proteína diaria',

      fmt(p.protein) + ' g',

      'Referencia orientativa'

    );

  }

  if (p.macros) {

    cards += stat(

      '📊',

      'Macronutrientes',

      fmt(p.macroProtein ?? p.protein) + ' / ' +

      fmt(p.fat) + ' / ' +

      fmt(p.carbs) + ' g',

      'Proteínas / Grasas / Hidratos',

      true

    );

  }

  if (p.water != null) {

    cards += stat(

      '💧',

      'Hidratación',

      fmt(p.water, 1) + ' L',

      'Referencia diaria orientativa'

    );

  }

  const safe = value =>

    String(value ?? '').replace(/[&<>"']/g, char => ({

      '&': '&amp;',

      '<': '&lt;',

      '>': '&gt;',

      '"': '&quot;',

      "'": '&#39;'

    }[char]));

  target.innerHTML = `

    <div class="df-card">

      <div class="df-eyebrow">

        ${available === 5 ? '✓ ANÁLISIS COMPLETADO' : 'ANÁLISIS PARCIAL'}

      </div>

      <h2>Tus resultados</h2>

      <p class="df-muted">

        ${p.height ? safe(p.height) + ' cm' : ''}

        ${p.weight ? ' · ' + safe(p.weight) + ' kg' : ''}

        ${p.age ? ' · ' + safe(p.age) + ' años' : ''}

        ${p.activity ? ' · Actividad ' + safe(activityText[p.activity] || '') : ''}

        ${p.goal ? ' · ' + safe(goalText[p.goal] || '') : ''}

      </p>

      <div class="df-summary-grid">

        ${cards}

      </div>

      <p class="df-muted" style="font-size:12px">

        Estas cifras son orientativas y no constituyen un diagnóstico

        ni una recomendación nutricional individualizada.

      </p>

    </div>

  `;

  const printButton = document.getElementById('df-print-report');

  if (printButton) {

    printButton.addEventListener('click', () => {

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({

        event: 'nutrition_report_print_requested'

      });

      window.print();

    });

  }

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({

    event: 'summary_viewed',

    completed_steps: available

  });

}

initSummary();

})();